// extracted by mini-css-extract-plugin
export default {"container":"iIRmBjTj","mobile":"mobile","logos":"kTSOB2dK","title":"TPwqhOfi","buttons":"uUUZ0418","description":"nuwSGfHe","agreement":"CPQLKxx0"};